import { Injectable } from '@angular/core';
import { CrudService } from '../crudService';
import {IID_CONFERMA_APPUNTAMENTO} from '@common/interfaces/interfaceData';
import { ConfermaAppuntamentoStore } from './confermaAppuntamento.store';
import { ConfermaAppuntamentoQuery } from './confermaAppuntamento.query';
import { ActionService } from '../action/action.service';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { Topics } from '@common/interfaces/topics';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.IID_CONFERMA_APPUNTAMENTO)
export class ConfermaAppuntamentoService extends CrudService<IID_CONFERMA_APPUNTAMENTO, ConfermaAppuntamentoStore, ConfermaAppuntamentoQuery> {

  constructor(
      public store: ConfermaAppuntamentoStore,
      public query: ConfermaAppuntamentoQuery,
      public actionService: ActionService,
      protected updateStrategy: ProjectEntityStoreStrategy) {
      super(
        Topics.IID_CONFERMA_APPUNTAMENTO,
        store,
        query,
        actionService,
        updateStrategy,
      );
    }

}
